import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const ConsentPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-500 via-green-400 to-blue-300 text-white relative overflow-hidden">

      {/* Glow Background */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-cyan-400/20 blur-3xl rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-emerald-400/20 blur-3xl rounded-full"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 py-10">

        {/* HEADER */}
        <div className="text-center mb-10">
          <h1 className="text-4xl sm:text-5xl font-bold">
            Consent Policy
          </h1>
          <p className="text-white/80 mt-2">
            AICA HEALTH — Data Processing Consent
          </p>
        </div>

        {/* SINGLE CONTENT CARD */}
        <div className="bg-white/10 border border-white/20 rounded-2xl p-6 sm:p-8 backdrop-blur-xl shadow-lg">

          <p className="text-white/80 whitespace-pre-line leading-relaxed text-sm sm:text-base">
By using the Platform, users expressly consent to AICA collecting, processing, analyzing, storing, and utilizing:

● physiological data,
● biometric-derived data,
● image-derived information,
● voice inputs,
● symptom information,
● behavioral interaction data,
● wellness information,
● screening information,
● associated metadata.

Users acknowledge and consent that:

● AI systems may analyze submitted information;
● outputs may be inference-based and probabilistic;
● certain features may remain investigational or calibration-dependent;
● anonymized or aggregated data may be used for:
○ research,
○ analytics,
○ AI model refinement,
○ calibration,
○ product improvement.

Users may withdraw consent subject to legal and operational limitations.

Use of the Platform constitutes affirmative consent to such processing.

          </p>
        </div>

        {/* FOOTER */}
        <div className="mt-12 flex items-center justify-between border-t border-white/20 pt-6">

          <p className="text-white/70 text-sm">
            © {new Date().getFullYear()} AICA HEALTH TECH Pvt Ltd
          </p>

          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 px-5 py-2 bg-white text-teal-700 font-semibold rounded-xl shadow hover:bg-gray-200 transition"
          >
            <ArrowLeft size={18} />
            Go Back
          </button>

        </div>

      </div>
    </div>
  );
};

export default ConsentPolicy;